import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from '@reduxjs/toolkit';

import { withinBettingContext } from 'app/contexts/betting';
import {
  calculateMatchDurationSeconds,
  formatMatchDurationTime,
} from 'app/lib/matchTimer';

// --

class MatchTimer extends Component {
  state = {
    seconds: null,
  };

  /**
   * @private
   */
  _tick = (timer, deltaSeconds) => {
    this.setState(() => ({
      seconds: calculateMatchDurationSeconds(timer, new Date()) - deltaSeconds, // todo: consider reverse case...
    }));
  };

  /**
   * @param {MatchTimer} timer
   */
  startTimer = (timer) => {
    const { deltaValue } = this.props;

    const deltaSeconds = deltaValue / 1000;

    this.setState({
      seconds: calculateMatchDurationSeconds(timer, new Date()) - deltaSeconds,
    });

    this.interval = nextSecond(() => {
      this._tick(timer, deltaSeconds);

      this.interval = setInterval(() => this._tick(timer, deltaSeconds), 1000);
    });
  };

  stopTimer = () => {
    clearInterval(this.interval);
    this.interval = null;
  };

  /**
   * Set current `gameTime` (timer.started === false)
   *
   * @param {number} gameTime
   */
  setGameTime = (gameTime) => {
    this.setState({
      seconds: gameTime,
    });
  };

  // --

  componentDidMount() {
    const { timer } = this.props;

    if (timer === null) {
      return;
    }

    if (timer.started) {
      this.startTimer(timer);
    }
    else {
      this.setGameTime(timer.gameTime);
    }
  }

  UNSAFE_componentWillReceiveProps({ timer }) {
    if (timer === null) {
      this.interval && this.stopTimer();
    }

    if (timer !== this.props.timer) {
      switch (true) {
        case (timer.started && !this.props.timer.started): // false > true switch
          this.startTimer(timer);
          break;

        case (!timer.started && this.props.timer.started): // true > false switch
          this.stopTimer();
          this.setGameTime(timer.gameTime);
          break;

        case (timer.started && this.props.timer.started): // true (doesn't changed)
          this.stopTimer();
          this.startTimer(timer);
          break;

        case (!timer.started && !this.props.timer.started): // false (doesn't changed)
          this.setGameTime(timer.gameTime);
          break;

        // no default
      }
    }
  }

  componentWillUnmount() {
    this.interval && this.stopTimer();
  }

  render() {
    const { children } = this.props;
    const { seconds } = this.state;

    if (children) {
      return children({ seconds });
    }

    return (
      <span>
        Время: {formatMatchDurationTime(Math.abs(seconds))}
      </span>
    );
  }
}

/**
 * Executes a given `fn` at the beginning of the next second.
 * @param {function} fn – a function to execute
 * @return {number} setTimeout's resulting timeout id, to give ability to cancel execution
 */
export function nextSecond(fn) {
  const time = (new Date()).getTime();
  return setTimeout(fn, (Math.ceil(time / 1000) * 1000) - time);
}

const mapStateToProps = (state, {
  $betting: {
    content: {
      selectors: {
        delta,
        matches,
      },
    },
  },
  matchId,
}) => {
  return {
    deltaValue: delta(state),
    timer: matches(state).getIn([matchId, 'timer'], null),
  };
};

export default compose(
  withinBettingContext,
  connect(mapStateToProps),
)(MatchTimer);
